import { TFunction } from 'i18next';

import { Dictionary } from '#/shared/dictionaries';
import { RoleType } from '#/shared/types';

export class RoleTypeDictionary extends Dictionary<typeof RoleType> {
  constructor(t: TFunction) {
    super(RoleType, t, 'roleType');
  }
}
